import { Box, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { CustomAvatar } from 'src/legacy/components/custom-avatar';
import { useLocales } from 'src/legacy/locales';
import { useActiveCompany } from 'src/organization/hooks/useActiveCompany';
import { useActiveCompanyUser } from 'src/organization/hooks/useActiveCompanyUser';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  display: 'flex',
  padding: theme.spacing(2, 2.5),
}));

const NavAccount = () => {
  const { translate } = useLocales();

  const { activeCompany } = useActiveCompany();
  const { activeCompanyUser } = useActiveCompanyUser();

  const displayName = `${activeCompanyUser?.first_name || ''} ${
    activeCompanyUser?.last_name || ''
  }`;

  return (
    <StyledRoot>
      <CustomAvatar alt="" name={displayName} src="" />

      <Box sx={{ minWidth: 0, ml: 2 }}>
        <Typography noWrap variant="subtitle2">
          {displayName}
        </Typography>

        <Typography noWrap sx={{ color: 'text.secondary' }} variant="body2">
          {`${translate(activeCompanyUser?.role)}`}
        </Typography>

        <Typography noWrap sx={{ color: 'text.secondary' }} variant="body2">
          {activeCompany?.name || ''}
        </Typography>
      </Box>
    </StyledRoot>
  );
};

export default NavAccount;
